import Log from 'services/Log';
import { isBotNavigation } from 'utils';

const getBrowser = () => {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|FxiOS|trident(?=\/))\/?\s*(\d+)/i) || [];

    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE '+(tem[1] || '');
    }

    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge?)\/(\d+)/);
        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');
    }

    M = M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];

    return {
        name: M[0] + (ua.indexOf('Mobile') !== -1 ? 'Mobile' : ''),
        version: M[1]
    };
};

const _verifyBrowserSupport = () => {
    if(isBotNavigation()) return true;

    const browser = getBrowser();

    const minBrowserSupports = {
        'FirefoxMobile': 55,
        'Firefox': 55,
        'ChromeMobile': 51,
        'Chrome': 51,
        'Edge': 15,
        'Opera': 38,
        'SafariMobile': 11,
        'Safari': 11,
        'MSIE': 10
    };

    const minBrowser = minBrowserSupports[browser.name];
    Log.debug(browser);

    return (!minBrowser || browser.version >= minBrowser);
};

const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

const BrowserSupport = {
    verifyBrowserSupport: _verifyBrowserSupport,
    getMobileOperatingSystem
}
export default BrowserSupport;
